<template>
  <div ref="scrollContainer" class="overview-sources">
    <div
      class="stats-promote"
      v-for="source in topFiveSources"
      :key="source.source_name"
      :style="`background:${colorParams.sourceCol}`"
    >
      <div class="source-ratings">
        <img
          :src="require(`../assets/reviews/${source.source}.png`)"
          :alt="source.source"
          class="rating-type-image"
        />
        <div class="rating">
          <strong class="h4" :style="`color:${colorParams.primaryTextCol}`">{{ source.averageRating }}</strong>
          <span class="h4 light-text">/5</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChannelWidget",
  props: ["data", "widgetId", "theme"],
  methods: {
    imageName(sourceName) {
      let name = sourceName;
      if (this.lightLogos && this.lightLogos.includes(name)) {
        name += "_light";
      }
      return name;
    },
    scrollContent() {
      const container = this.$refs.scrollContainer;
      container.scrollBy({
        left: container.offsetWidth,
        behavior: "smooth",
      });
    },
  },
  computed: {
    colorParams() {
      if (!this.theme) {
        return {
          sourceCol: "#ffffff",
          primaryTextCol: "#00aef1",
        };
      }

      let theme;
      try {
        theme = JSON.parse(this.theme);
      } catch (e) {
        return {
          sourceCol: "#ffffff",
          primaryTextCol: "#00aef1",
        };
      }

      if (theme && theme.bodyCol) {
        document.body.style.backgroundColor = theme.bodyCol;
      }

      return {
        sourceCol: theme && theme.sourceCol ? theme.sourceCol : "#ffffff",
        primaryTextCol: theme && theme.primaryTextCol ? theme.primaryTextCol : "#00aef1",
      };
    },
    sortedSources() {
      const stats = this.data.stats;
      return stats.sort(
        (a, b) => parseFloat(b.averageRating) - parseFloat(a.averageRating)
      );
    },
    topFiveSources() {
      return this.sortedSources.slice(0, 5);
    },
  },
  mounted() {
    if (window.innerWidth <= 600) {
      this.scrollInterval = setInterval(this.scrollContent, 5000);
    }
  },
  beforeDestroy() {
    clearInterval(this.scrollInterval);
  },
};
</script>

<style lang="scss" scoped>
.stats-promote {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 0 20px 0 20px;
  background-color: #ffffff;
  margin: 10px;
  transition: all 0.3s ease;
  height: 100px; // Set a fixed height for consistency
  width: 200px;

  &:hover {
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
  }

  &.dark {
    background-color: #212b3c;
  }

  @media (max-width: 600px) {
    flex: 0 0 40%;
  }

  @media (max-width: 400px) {
    flex: 0 0 83%;
  }
}

.overview-sources {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  justify-content: flex-start;
  align-items: stretch; // Stretch items to fill the container
  height: auto; // Adjust to your preference

  @media (max-width: 600px) {
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
  }
}

.source-ratings {
  display: flex;
  flex-direction: column;
  justify-content: space-around; // Evenly space the children
  align-items: center;
  height: 100%; // Take full height of the container
}

.rating-type-image {
  object-fit: scale-down;
  max-width: 100%;
  height: 50%; // Take half of the container height
}

.rating {
  height: 50%; // Take the other half of the container height
  display: flex;
  flex-direction: row;
  align-items: center; // Center content horizontally
}
// Font styles
@import url("https://fonts.googleapis.com/css?family=Open+Sans");

%font-style {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  font-family: "Open Sans", sans-serif;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  @extend %font-style;
}

strong {
  color: #00aef1;
}

.light-text {
  color: #90919e;
  font-size: 12px;
  font-weight: 600;
}
</style>
